var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-wrapper"},[_c('div',{staticClass:"input-name"},[_vm._v(_vm._s(_vm.inputName))]),(_vm.coins)?_c('div',{staticClass:"coins"},[_vm._v("\n        1"),_c('div',{staticClass:"coin"})]):_vm._e(),_c('input',{attrs:{"type":"text"},domProps:{"value":_vm.visValue},on:{"input":_vm.emitValue}})])
}
var staticRenderFns = []

export { render, staticRenderFns }